export const ERROR_INVALID_PRODUCT_ID = 'Invalid product ID';
